export default {
  "space": "j597amcfl36h",
  "accessToken": "e4c9ac0e1abf3d57915dafd809be8b1e52f2f9b2e5ba828a3d38659a8837179f"
};
